module.exports = __webpack_public_path__ + "static/media/7.5ca1ecd8.jpeg";